import { render, staticRenderFns } from "./UnitCertificate.vue?vue&type=template&id=0bc0491d&scoped=true"
import script from "./UnitCertificate.vue?vue&type=script&lang=js"
export * from "./UnitCertificate.vue?vue&type=script&lang=js"
import style0 from "./UnitCertificate.vue?vue&type=style&index=0&id=0bc0491d&prod&lang=css"
import style1 from "./UnitCertificate.vue?vue&type=style&index=1&id=0bc0491d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc0491d",
  null
  
)

export default component.exports